import { Building2, Shield, TrendingUp } from 'lucide-react';
import SEO from '../components/shared/SEO';

const MissionPage = () => {
  return (
    <div data-testid="mission-page">
      <SEO 
        title="Our Mission | Build. Protect. Grow."
        description="Queen B Logistics empowers trucking professionals through our Build • Protect • Grow framework—helping carriers launch, stay compliant, and scale profitably."
        canonical="https://queenblogistics.com/mission"
        keywords="Queen B Logistics mission, Build Protect Grow, trucking dispatch mission, authority launch, compliance management, dispatch services"
      />
      {/* Page Header */}
      <section className="page-header relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="limited-badge mb-6">
            Build. Protect. Grow.
          </div>
          <h1 className="font-['Barlow_Condensed'] text-6xl md:text-7xl lg:text-8xl font-black text-white uppercase">
            Our<br />
            <span className="text-[#D4AF37]">Mission</span>
          </h1>
        </div>
        
        {/* Bee Watermark */}
        <div className="absolute -right-20 top-20 text-[300px] text-white/[0.02] font-['Barlow_Condensed'] font-black select-none pointer-events-none">
          &#9733;
        </div>
      </section>

      {/* Content */}
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          {/* Gold Highlight Quote */}
          <div className="mb-16">
            <div className="h-1 w-16 bg-[#D4AF37] mb-8" />
            <blockquote className="font-['Barlow_Condensed'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#D4AF37] leading-tight">
              To empower trucking professionals at every stage of their journey—helping them 
              Build their authority, Protect their compliance, and Grow their revenue.
            </blockquote>
          </div>

          {/* Body Text */}
          <div className="space-y-6 text-white/70 text-lg leading-relaxed">
            <p>
              At Queen B Logistics, we believe every owner-operator deserves a clear path from 
              startup to success. That's why we created the <span className="text-[#D4AF37] font-semibold">Build • Protect • Grow</span> framework—a 
              comprehensive system designed to guide carriers through every phase of their business lifecycle.
            </p>
            
            <p>
              We don't just dispatch loads. We partner with carriers to launch authorities the right way, 
              maintain compliance so they never face penalties or shutdowns, and scale operations 
              profitably through dedicated dispatch support.
            </p>

            <p>
              Our mission is to level the playing field—giving owner-operators and small fleets 
              access to the same structured guidance, operational support, and growth opportunities 
              that large carriers have always enjoyed.
            </p>

            <p>
              By limiting our capacity and focusing on quality over quantity, we ensure every 
              carrier in the hive receives personalized attention, expert guidance, and the 
              accountability needed to succeed in this industry.
            </p>
          </div>

          {/* Build Protect Grow Framework */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 bg-[#121212] border border-[#CD7F32]/30 hover:border-[#CD7F32] transition-colors">
              <div className="w-12 h-12 bg-[#CD7F32]/10 flex items-center justify-center mb-4">
                <Building2 className="w-6 h-6 text-[#CD7F32]" />
              </div>
              <h3 className="font-['Barlow_Condensed'] text-xl font-bold text-[#CD7F32] mb-2">
                Build
              </h3>
              <p className="text-white/50 text-sm">
                Launch your authority with structured guidance, proper formation, and a clear roadmap to activation.
              </p>
            </div>
            
            <div className="p-6 bg-[#121212] border border-[#C0C0C0]/30 hover:border-[#C0C0C0] transition-colors">
              <div className="w-12 h-12 bg-[#C0C0C0]/10 flex items-center justify-center mb-4">
                <Shield className="w-6 h-6 text-[#C0C0C0]" />
              </div>
              <h3 className="font-['Barlow_Condensed'] text-xl font-bold text-[#C0C0C0] mb-2">
                Protect
              </h3>
              <p className="text-white/50 text-sm">
                Stay compliant with proactive deadline monitoring, renewal alerts, and regulatory updates.
              </p>
            </div>
            
            <div className="p-6 bg-[#121212] border border-[#D4AF37]/30 hover:border-[#D4AF37] transition-colors">
              <div className="w-12 h-12 bg-[#D4AF37]/10 flex items-center justify-center mb-4">
                <TrendingUp className="w-6 h-6 text-[#D4AF37]" />
              </div>
              <h3 className="font-['Barlow_Condensed'] text-xl font-bold text-[#D4AF37] mb-2">
                Grow
              </h3>
              <p className="text-white/50 text-sm">
                Scale your revenue with dedicated dispatchers, rate negotiation, and operational optimization.
              </p>
            </div>
          </div>

          {/* Bottom Quote */}
          <div className="mt-16 pt-12 border-t border-white/10">
            <p className="text-white/40 italic text-center">
              "Driven in Excellence. Crowned in Confidence."
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MissionPage;
